<template>
  <div class="menu">
    <!-- está logueado -->
    <template v-if="logged">
      <b-navbar toggleable="lg" type="light" variant="faded">
        <router-link :to="{name:'inicio'}">
          <b-navbar-brand><img src="@/assets/img/logotipo.png" height="90px;"></b-navbar-brand>
        </router-link>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <!-- Navbar dropdowns -->
            <b-nav-item-dropdown text="Gestión" left>
              <b-dropdown-item :to="{ name:'pacientes' }">Pacientes</b-dropdown-item>
              <b-dropdown-item :to="{ name:'sesiones' }">Sesiones</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown text="Bonos" left>
              <b-dropdown-item :to="{ name:'bonos' }">Bonos activos</b-dropdown-item>
              <b-dropdown-item :to="{ name:'bonos_gastados' }">Bonos consumidos</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown v-if="isAdmin" text="Administración" left>
              <b-dropdown-item :to="{ name: 'fichajes' }">Control horario</b-dropdown-item>
              <b-dropdown-item :to="{ name:'pagos' }">Pagos</b-dropdown-item>
              <b-dropdown-item :to="{ name:'usuarios' }">Usuarios</b-dropdown-item>
              <b-dropdown-item :to="{ name:'facturas' }">Facturas</b-dropdown-item>
              <b-dropdown-item :to="{ name:'configuracion' }">Datos de configuración</b-dropdown-item>
              <b-dropdown-item :to="{ name:'estadisticas' }">Estadísticas</b-dropdown-item>
            </b-nav-item-dropdown>
            <!-- sesión -->
            <b-nav-item-dropdown right>
              <template v-slot:button-content>
                <!-- <b-avatar size="lg" :src="gravatar"></b-avatar> -->
                <b-icon icon="person" style="width:20px; height:20px; margin-right:5px;" scale="1.3" variant="success">
                </b-icon>
                {{ usrLogin.nombre }}
              </template>
              <b-dropdown-item :to="{ name: 'mi-fichaje' }">Fichar</b-dropdown-item>
              <b-dropdown-item :to="{ name:'cambiopsw' }">Cambiar contraseña</b-dropdown-item>
              <b-dropdown-item @click="cerrarSesion">Cerrar sesión</b-dropdown-item>
            </b-nav-item-dropdown>
            <!-- fin/sesión -->
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <span class="ml-4">Gestión Fisio Sport ISKANDRIA. Versión {{ version }}</span>
    </template>

    <!-- no está logueado y/o no está verificado el email -->
    <template v-else>
      <b-navbar toggleable="lg" type="light" variant="faded">
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-text>
              <span style="font-size:2rem" class="m-0">
                <b-icon icon="person-fill" class="rounded-circle bg-danger p-1" variant="light"></b-icon>
              </span>
            </b-nav-text>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </template>

  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  export default {
    name: 'Cabecera',
    data() {
      return {
        chats: [{
          id: 0,
        }],
      }
    },
    computed: {
      ...mapState('auth', ['logged']),
      ...mapState(['version']),
      ...mapState('fichajes', ['estadoActual', 'ultimoFichaje']),
      ...mapGetters('fichajes', [
        'puedeTrabajar',
        'estaTrabajando',
        'estaEnPausa',
        'horasTrabajadas'
      ]),
      isAdmin: function(){
        return this.usrLogin.roll=='adm' ? true : false
      },
      usrLogin() {
        return this.$store.state.auth.usrLogin;
      },
      roll() {
        return this.$store.state.auth.usrLogin.roll;
      },
      token() {
        return this.$store.state.auth.usrLogin.token;
      },
      fichajeTexto() {
        const estados = {
          'sin_fichajes': 'Sin fichar',
          'trabajando': 'Trabajando',
          'en_pausa': 'En pausa',
          'fuera': 'Fuera'
        };
        return estados[this.estadoActual] || 'Fichaje';
      },

      fichajeIcon() {
        const iconos = {
          'sin_fichajes': 'clock',
          'trabajando': 'clock-fill',
          'en_pausa': 'pause-circle-fill',
          'fuera': 'x-circle'
        };
        return iconos[this.estadoActual] || 'clock';
      },

      fichajeVariant() {
        const variantes = {
          'sin_fichajes': 'secondary',
          'trabajando': 'success',
          'en_pausa': 'warning',
          'fuera': 'danger'
        };
        return variantes[this.estadoActual] || 'secondary';
      },
    },

    methods:{
      ...mapActions('auth', ['cerrarSesion']),
      ...mapActions('fichajes', ['fichar', 'cargarUltimoFichaje']),
      async ficharRapido(tipo) {
        this.$bvToast.toast('Procesando fichaje...', {
          title: 'Fichaje',
          variant: 'info',
          solid: true,
          autoHideDelay: 1500
        });

        const resultado = await this.fichar({ tipo, notas: null });

        if (resultado.success) {
          const mensajes = {
            'entrada': '¡Entrada registrada! Buen día.',
            'salida': '¡Salida registrada! Hasta mañana.',
            'pausa_inicio': 'Pausa iniciada. ¡Disfruta!',
            'pausa_fin': 'Pausa finalizada. ¡A trabajar!'
          };

          this.$bvToast.toast(mensajes[tipo], {
            title: '✅ Fichaje exitoso',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000
          });
        } else {
          this.$bvToast.toast(resultado.error, {
            title: '❌ Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          });
        }
      },
    },

    mounted() {
      if (this.logged) {
        this.cargarUltimoFichaje();
      }
    }
  }
</script>